import React, { memo } from "react";
import { useDimensions } from "../../../hooks/useDimensions";
import { generateButtonClasses } from "./generateButtonClasses";
import { Render } from "../../../containers/homepage/Render";
import"./Button.css";

const Button = memo((props) => {
  const {
    title,
    variant = "contained",
    color = "primary",
    widthInPercent,
    disabled = false,
    type = "button",
    className = "",
    onClick,
    accessor = "button",
    fullWidth,
    isSubmitting,
    icon,
    iconPosition = "beforeText",
  } = props;

  const { isXS, isLG } = useDimensions();

  return (
    <button
      id={accessor}
      onClick={onClick}
      type={type}
      disabled={disabled || isSubmitting}
      style={{
        ...(widthInPercent && {
          width: !isXS && isLG ? `${widthInPercent}%` : "100%",
        }),
      }}
      className={`${generateButtonClasses(
        variant,
        color,
        disabled || isSubmitting,
        fullWidth,
        className
      )}`}
    >
      {isSubmitting ? (
        <div className="spinner-container">
          <div className="spinner" />
        </div>
      ) : icon ? (
        <span
          className={`icon-wrapper ${
            iconPosition === "beforeText"
              ? "icon-before"
              : iconPosition === "afterText"
              ? "icon-after"
              : iconPosition === "centerBeforeText"
              ? "icon-center-before"
              : "icon-center-after"
          }`}
        >
          <span>{icon}</span>
          <Render if={title !== ""}>
            <span>{title}</span>
          </Render>
        </span>
      ) : (
        <span className="title-wrapper">
          <p style={{ marginBottom: "0px" }}>{title}</p>
        </span>
      )}
    </button>
  );
});

export default Button;
